const loadPDFJS = async () => {
	const pdfjs = await import('pdfjs-dist/build/pdf');
	await import('pdfjs-dist/build/pdf.worker.entry');
	return pdfjs;
};

const convertPDFToImages = (file) => {
	return new Promise(async function(resolve, reject) {
			const PDFJS = await loadPDFJS();
			let fileReader = new FileReader();
			fileReader.onload = function(ev)
			{
				let pdfdoc = PDFJS.getDocument(fileReader.result);
				pdfdoc.promise.then
				(
					function getPDF(pdf)
					{
						let pages = [];
						for(let i = 1; i <= pdf.numPages; i++)
						{
							pages.push(pdf.getPage(i).then
							(
								function getPDFPage(page)
								{
									var scale = 2;
									var viewport = page.getViewport({scale});
									var canvas = document.createElement("canvas");
									var context = canvas.getContext('2d');
		
									canvas.height = viewport.height;
									canvas.width = viewport.width;
			
									var task = page.render({canvasContext: context, viewport: viewport})
		
									return task.promise.then
									(
										function()
										{
											return canvas.toDataURL('image/png');
										}
									);
		
								}
							));
						}
						Promise.all(pages).then
						(
							(images) => {
								resolve(images);
							}
						);
					}, 
					(err) => {
						reject(err)
					}
				);
			}
			fileReader.readAsArrayBuffer(file);
		}
	);
}

const createPDFThumbnail = (file) => {
	return new Promise(function(resolve, reject) {
		(async () => {
			try {
				const PDFJS = await loadPDFJS();
				let fileReader = new FileReader();
				fileReader.onload = function(ev) 
				{
					let pdfdoc = PDFJS.getDocument(fileReader.result);
					pdfdoc.promise.then
					(
						function getPDF(pdf)
						{
							pdf.getPage(1).then
							(
								function getPDFPage(page)
								{
									var scale = 0.75;
									var viewport = page.getViewport({scale});
									var canvas = document.createElement("canvas");
									var context = canvas.getContext('2d');
		
									canvas.height = viewport.height;
									canvas.width = viewport.width;
			
									var task = page.render({canvasContext: context, viewport: viewport})
		
		
									task.promise.then
									(
										function()
										{
											resolve(canvas.toDataURL('image/png'));
										}
									);
			
								}
							);
						}, 
						(err) => {
							reject(err)
						}
					);	
				}
				fileReader.readAsArrayBuffer(file);
			} catch(ex) {
				reject(ex);
			}
		})();

	});
}

const fromBlob = (blob) => {
    //do the blob thing.
    //of course we haven't used a blob yet so lets worry then :)
}

export default createPDFThumbnail;

export { createPDFThumbnail, convertPDFToImages }